export const getCurrentLeadStatus = () => {
    const statusId = document.querySelector('[id="card_status_view_mode"]').getAttribute("data-status-id")
    return statusId
}